const $ = require('jquery');
const footer = require('./footer');
if (!window.$) {
  window.$ = $;
}
$(document).ready(function () {
  // 初始化内容
  let lastItem = $('#productsMenu > li:eq(0)');
  lastItem.addClass('active');
  $(`#products .products-intro:eq(${lastItem.data('index')})`).addClass('show');

  $('#productsMenu').on('click', function (e) {
    const target = $(e.target);
    if (lastItem.data('index') !== target.data('index')) {
      target.addClass('active');
      lastItem.removeClass('active');
      // 右侧内容更新
      $(`#products .products-intro:eq(${lastItem.data('index')})`).removeClass('show');
      $(`#products .products-intro:eq(${target.data('index')})`).addClass('show');
      lastItem = target;
    }
  });

  // 聚合底部布局
  $('#footer').html($(footer));
  // 处理注册、返回官网链接
  $('.register-btn').on('click', function () {
    window.location.href = 'https://www.juhe.cn/register' + window.location.search;
  });
  $('.juhe-link').on('click', function () {
    window.location.href = 'https://www.juhe.cn/' + window.location.search;
  });
});
